import { useMsal } from '@azure/msal-react'
import { useState, useEffect } from 'react'
import { resolveTabAccount } from '../auth/tabAccount'

export const LOGIN_REQUEST = { scopes: ['openid', 'profile', 'email'] }

export function useAccessToken(): [string] {
  const { instance, accounts } = useMsal()
  const [token, setToken] = useState('')

  useEffect(() => {
    const account = resolveTabAccount(instance.getActiveAccount(), accounts)
    if (!account) {
      return
    }

    instance
      .acquireTokenSilent({ account, ...LOGIN_REQUEST })
      .then(result => setToken(result.idToken))
      .catch(() => {}) // silent failure — callers guard on empty token
  }, [instance, accounts])

  return [token]
}
